import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { CamelCasePipe } from './camel-case.pipe';
import { CarrierDetailsPipe } from './carrier-details.pipe';
import { ConvertStatusClassNamesPipe } from './convert-status-class-names.pipe';
import { DelayHoursPipe } from './delay-hours.pipe';
import { DelimiterPipe } from './delimiter.pipe';
import { ElapsedTimePipe } from './elapsed-time.pipe';
import { EmptyToNotAvailablePipe } from './empty-to-not-available.pipe';
import { JoinByDelimiterPipe } from './join-by-delimiter.pipe';
import { KebabCasePipe } from './kebab-case.pipe';
import { LastArrayElementPipe } from './last-array-element.pipe';
import { LocalePipe } from './locale.pipe';
import { MathAbsPipe } from './math-abs.pipe';
import { MinutesToHoursPipe } from './minutes-to-hours.pipe';
import { MonitoringFilterAdjustUiPipe } from './monitoring-filter-adjust-ui.pipe';
import { NullToEmptyStringPipe } from './null-to-empty-string.pipe';
import { NullToNotAvailablePipe } from './null-to-not-available.pipe';
import { RegionPipe } from './region.pipe';
import { RoleGroupPipe } from './role-group.pipe';
import { SentenceCasePipe } from './sentence-case.pipe';
import { SortByPipe } from './sort-by.pipe';
import { StartCasePipe } from './start-case.pipe';
import { TimestampToHoursPipe } from './timestamp-to-hours';
import { ToLocalOffsetPipe } from './to-local-offset.pipe';
import { ToLocalTimezonePipe } from './to-local-timezone.pipe';
import { TruckLoadingTypePipe } from './truck-loading-types.pipe';
import { TruncatePipe } from './truncate.pipe';
import {
  UliFilterCompartmentsByTypePipe,
  UliFindFilteredCompartmentNamePipe,
  UliSimilarAddressPipe,
  UliTransformCompartmentPipe,
} from './uli-creation-pipes';
import { WaybillHeaderTitlePipe } from './waybill-header-title.pipe';
import { PartnerTypePipe } from './partner-type.pipe';
import { RolesJoinPipe } from './roles-join.pipes';
import { SafeHtmlPipe } from './safe-html.pipe';
import { CountriesCodeToNamePipe } from './country-code-to-name.pipe';
import { PartnerDetailsPipe } from './partner-details.pipe';

const PIPES = [
  CamelCasePipe,
  DelayHoursPipe,
  KebabCasePipe,
  LastArrayElementPipe,
  MathAbsPipe,
  MonitoringFilterAdjustUiPipe,
  NullToNotAvailablePipe,
  NullToEmptyStringPipe,
  RegionPipe,
  SortByPipe,
  SafeHtmlPipe,
  TimestampToHoursPipe,
  StartCasePipe,
  DelimiterPipe,
  EmptyToNotAvailablePipe,
  SentenceCasePipe,
  RoleGroupPipe,
  MinutesToHoursPipe,
  ToLocalTimezonePipe,
  CarrierDetailsPipe,
  ToLocalOffsetPipe,
  ElapsedTimePipe,
  JoinByDelimiterPipe,
  ConvertStatusClassNamesPipe,
  TruckLoadingTypePipe,
  LocalePipe,
  WaybillHeaderTitlePipe,
  TruncatePipe,
  PartnerTypePipe,
  UliTransformCompartmentPipe,
  UliSimilarAddressPipe,
  UliFindFilteredCompartmentNamePipe,
  UliFilterCompartmentsByTypePipe,
  RolesJoinPipe,
  CountriesCodeToNamePipe,
  PartnerDetailsPipe,
];

@NgModule({
  declarations: PIPES,
  exports: PIPES,
  providers: [...PIPES, DatePipe],
})
export class PipesModule {}
